import { render, staticRenderFns } from "./TermoDesentranhamentoRedacao.vue?vue&type=template&id=21ae4156&scoped=true"
import script from "./TermoDesentranhamentoRedacao.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoRedacao.vue?vue&type=script&lang=js"
import style0 from "./TermoDesentranhamentoRedacao.vue?vue&type=style&index=0&id=21ae4156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae4156",
  null
  
)

export default component.exports